import { FieldMetaProps } from 'formik'
import { useLayoutEffect } from 'react'

const DATA_ATTRIBUTE = 'data-focus-on-error'

// Add a specific attribute to a form element if it has an error (Then used in method below)
export const addErrorDataAttribute = (meta: FieldMetaProps<{}>) =>
  meta.error && meta.touched ? { [DATA_ATTRIBUTE]: 'true' } : {}

interface Props<T> {
  apiError: T
}

type V = {}

// Detect elements with errors on form (Method Above) and scroll to first one
export const ScrollOnError: React.FC<Props<V>> = ({ apiError }) => {
  useLayoutEffect(() => {
    if (apiError) {
      setTimeout(() => {
        const firstError = document.querySelector(
          `[${DATA_ATTRIBUTE}]`
        ) as HTMLInputElement
        if (firstError) {
          firstError.focus()
        }
      }, 100)
    }
  }, [apiError])

  return null
}
